import "./edit-util-transport-location.scss";

import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderButton from "@shared/ui/header-button/header-button";
import HeaderContent from "@shared/ui/header-content/header-content";
import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import { ConfirmDialog } from "primereact/confirmdialog";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormUtilTransportLocation from "../form-util-transport-location/form-util-transport-location";
import { useEditUtilTransportLocation } from "./edit-util-transport-location.hook";

export function EditUtilTransportLocation() {
  const {
    utilTransportLocationData,
    isLoading,
    utilTransportLocationError,
    formMethod,
    actions,
    handleBack,
    handleAction,
  } = useEditUtilTransportLocation();

  const title = utilTransportLocationData?.name ? (
    <h1>{utilTransportLocationData?.name}</h1>
  ) : (
    <h1>Edit Transport Location</h1>
  );
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
        <FormUtilTransportLocation />
      </section>
    </div>
  );

  return (
    <div id="EditUtilTransportLocation" className="util-transport-location">
      <HeaderContent
        title={title}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>

      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          {utilTransportLocationError && !isLoading && displayError}
          {!isLoading ? mainContent : null}
        </FormProvider>
      </section>
    </div>
  );
}

export default EditUtilTransportLocation;
